const ALLOWED_ROUTE_TYPES = new Set(["driving", "walking", "random"]);

export function normalizeRouteTypeFilter(routeType) {
  const normalized = String(routeType || "")
    .trim()
    .toLowerCase();
  return ALLOWED_ROUTE_TYPES.has(normalized) ? normalized : "";
}

export function filterRoutesByType(routes = [], routeType) {
  const normalizedType = normalizeRouteTypeFilter(routeType);
  const safeRoutes = Array.isArray(routes) ? routes : [];
  if (!normalizedType) return safeRoutes;
  return safeRoutes.filter(
    (route) =>
      String(route?.type || "")
        .trim()
        .toLowerCase() === normalizedType,
  );
}

export function filterRoutesByTypeAndId(routes = [], routeType, routeId = "") {
  const byType = filterRoutesByType(routes, routeType);
  const normalizedRouteId = String(routeId || "").trim();
  if (!normalizedRouteId) return byType;
  return byType.filter((route) => {
    const candidateIds = [
      route?.startRouteTypeId,
      route?.routeTypeId,
      route?.tourTypeId,
      route?.id,
    ]
      .map((value) => String(value || "").trim())
      .filter(Boolean);
    return candidateIds.includes(normalizedRouteId);
  });
}
